import { apiService } from './apiService';
import { User } from '../types/user';

class UserService {
  private static instance: UserService;
  private userCache: User | null = null;

  private constructor() {}

  public static getInstance(): UserService {
    if (!UserService.instance) {
      UserService.instance = new UserService();
    }
    return UserService.instance;
  }

  public async getUserInfo(): Promise<User | null> {
    try {
      const response = await apiService.get<{ authenticated: boolean; user: User }>('/api/auth/session');
      if (!response.data.authenticated || !response.data.user) {
        return null;
      }
      
      this.userCache = response.data.user;

      // Set the first client as selected if none is selected
      const assignments = response.data.user.client_assignments || [];
      if (!localStorage.getItem('selectedClientId') && assignments.length > 0) {
        const firstClientId = assignments[0].client_id;
        localStorage.setItem('selectedClientId', firstClientId.toString());
      }

      return response.data.user;
    } catch (error) {
      console.error('Error fetching user info:', error);
      return null;
    }
  }

  public getCachedUser(): User | null {
    return this.userCache;
  }

  public clearCache(): void {
    this.userCache = null;
  }

  public async getUserById(userId: number): Promise<User> {
    try {
      const response = await apiService.get<User>(`/api/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting user by ID:', error);
      throw error;
    }
  }
}

export default UserService.getInstance();

// Function to get current user from backend
export const getCurrentUser = async (userId: number): Promise<User> => {
  try {
    const response = await apiService.get<User>(`/api/users/${userId}`);
    return response.data;
  } catch (error) {
    console.error('Error getting current user:', error);
    throw error;
  }
};

export const userService = {
  async getUserInfo(): Promise<User> {
    try {
      const response = await apiService.get<{ authenticated: boolean; user: User }>('/api/auth/session');
      return response.data.user;
    } catch (error) {
      console.error('Error getting user info:', error);
      throw error;
    }
  },

  async getUserById(userId: number): Promise<User> {
    try {
      const response = await apiService.get<User>(`/api/users/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting user by ID:', error);
      throw error;
    }
  }
}; 